import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import AdminHeader from "../components/AdminHeader";
import { useAudioSystem } from "../context/AudioContext";

export default function Settings() {
  const { setSettings } = useAudioSystem();
  const [local, setLocal] = useState(null);

  useEffect(() => { api.get("/settings").then((r) => setLocal(r.data)); }, []);

  const save = async (patch) => {
    const res = await api.patch("/settings", patch);
    setLocal(res.data);
    setSettings(res.data);
    toast.success("Settings saved");
  };

  if (!local) return <div className="min-h-screen bg-[#09090B] p-6 text-white">Loading…</div>;

  const Toggle = ({ field, title, desc }) => (
    <div className="flex items-center justify-between bg-[#18181B] border border-white/10 rounded-2xl p-5">
      <div className="pr-4">
        <div className="font-display font-black text-lg text-white">{title}</div>
        <div className="text-[#71717A] text-sm">{desc}</div>
      </div>
      <button data-testid={`setting-${field}`} onClick={() => save({ [field]: !local[field] })}
        className={`w-24 h-12 rounded-xl font-display font-black text-sm ${local[field] ? "bg-[#00FA9A] text-black" : "bg-[#27272A] text-[#A1A1AA]"}`}>
        {local[field] ? "ON" : "OFF"}
      </button>
    </div>
  );

  return (
    <div className="min-h-screen bg-[#09090B] p-4 md:p-6">
      <AdminHeader title="SETTINGS" accent="#FFCC00" />
      <div className="space-y-4 max-w-2xl">
        <Toggle field="confirm_stop_all" title="Confirm Stop All Audio" desc="Require a second tap before stopping all audio." />
        <Toggle field="default_resume_music" title="Auto-Resume Music" desc="Allow eligible recordings to resume music after they finish. Emergency recordings never auto-resume." />
        <div className="flex items-center justify-between bg-[#18181B] border border-white/10 rounded-2xl p-5">
          <div className="pr-4">
            <div className="font-display font-black text-lg text-white">Default Master Volume</div>
            <div className="text-[#71717A] text-sm">Starting volume for priority audio (0–100).</div>
          </div>
          <div className="flex items-center gap-2">
            <button onClick={() => save({ master_volume: Math.max(0, local.master_volume - 5) })} className="w-12 h-12 rounded-xl bg-[#27272A] text-white text-2xl font-bold">−</button>
            <span data-testid="setting-volume-value" className="w-16 text-center font-display font-black text-2xl text-white">{local.master_volume}%</span>
            <button onClick={() => save({ master_volume: Math.min(100, local.master_volume + 5) })} className="w-12 h-12 rounded-xl bg-[#27272A] text-white text-2xl font-bold">+</button>
          </div>
        </div>
      </div>
    </div>
  );
}
